import axios from 'axios';
import { showFailToast } from 'vant';

// 创建axios实例
const instance = axios.create({
  baseURL: '/', // 基础URL
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器
instance.interceptors.request.use(
  config => {
    // 从localStorage中获取用户信息
    const userInfo = localStorage.getItem('userInfo');
    if (userInfo) {
      try {
        const parsedUserInfo = JSON.parse(userInfo);
        // 如果有token，添加到请求头
        if (parsedUserInfo.token) {
          config.headers.Authorization = `Bearer ${parsedUserInfo.token}`;
        }
      } catch (error) {
        console.error('解析用户信息失败:', error);
      }
    }

    // get请求 添加timestemap 防止缓存
    if (config.method === 'get') {
      const timestamp = new Date().getTime();
      config.params = config.params || {};
      config.params.timestamp = timestamp;
    }

    return config;
  },
  error => {
     showFailToast(error.message || '请求失败');
  }
);

// 响应拦截器
instance.interceptors.response.use(
  response => {
    // 直接返回响应数据
    return response;
  },
  error => {
    // 处理401错误（未授权）
    if (error.response && error.response.status === 401) {

      if(error.response.request.responseURL.indexOf('/liaison-officers/login') !== -1){
        return error.response;
      }

      // 清除本地存储的用户信息
      localStorage.removeItem('userInfo');
      // 倒计时秒数
      let countdown = 3;
      // 显示带有倒计时的提示
      showFailToast({ message: `登录已过期，${countdown}秒后自动跳转到登录页面`, duration: 0 });
      // 倒计时函数
      const timer = setInterval(() => {
        countdown--;
        if (countdown > 0) {
          showFailToast({ message: `登录已过期，${countdown}秒后自动跳转到登录页面`, duration: 0 });
        } else {
          // 清除定时器
          clearInterval(timer);
          // 跳转到登录页面
          window.location.href = '/';
        }
      }, 1000);
    }

    // 显示错误信息
    showFailToast(error.message || '请求失败');
  }
);

export default instance;